// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"6447dd264de14fd698f9","293":"6b42dbedb3e8418891f8","522":"2db2dc8cf7075cb01bcf"}[chunkId] + ".js";
};